import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    datepickerContainer: {
      '& .react-datepicker-wrapper': {
        maxWidth: '100%',
        width: '100%',
        '& .react-datepicker__input-container input': {
          maxWidth: '100%',
          width: '100%',
          background: 'inherit',
        },
      },
      '& .react-datepicker__navigation': {
        height: 8,
        width: 8,
      },
      '& .react-datepicker__close-icon': {
        display: 'flex',
        alignItems: 'flex-end',
        paddingBottom: 0,
        bottom: 1,
        top: 'auto',
        height: 'auto',
        padding: 0,
        marginRight: 22,
        borderRadius: '50%',
        '&::after': {
          background: 'inherit',
          color: theme.palette.secondary.light,
          fontSize: 25,
          padding: 15,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        '&:hover': {
          background: '#efefef',
        },
      },
      '& label.MuiInputLabel-formControl': {
        fontSize: '14px !important',
      },
      '& .react-datepicker__tab-loop': {
        '& .react-datepicker-popper': {
          zIndex: 2,
          '& .react-datepicker': {
            borderRadius: 0,
            border: 'none',
            boxShadow: theme.shadows[4],
            color: theme.palette.text.primary,
            fontFamily: theme.typography.fontFamily,
            '& .react-datepicker__triangle': {
              display: 'none',
            },
            '& .react-datepicker__navigation--previous': {
              border: 'solid #000',
              borderWidth: '0 2px 2px 0',
              display: 'inline-block',
              left: 20,
              padding: 2,
              top: 18,
              transform: 'rotate(135deg)',
            },
            '& .react-datepicker__day--today': {
              border: '1px solid #229688',
              borderRadius: '50%',
              fontWeight: 500,
            },
            '& .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button)':
              {
                border: 'solid #000',
                borderWidth: '0 2px 2px 0',
                display: 'inline-block',
                padding: 2,
                right: 130,
                top: 18,
                transform: 'rotate(-45deg)',
              },
            '& .react-datepicker__month-container': {
              '& .react-datepicker__header': {
                backgroundColor: theme.palette.common.white,
                border: 'none',
                borderRadius: 0,
                paddingTop: 15,
                '& .react-datepicker__current-month': {
                  fontSize: theme.typography.appFontSize,
                  fontWeight: 500,
                },
                '& .react-datepicker__day-names': {
                  display: 'flex',
                  marginTop: 10,
                  justifyContent: 'center',
                  '& .react-datepicker__day-name': {
                    alignItems: 'center',
                    color: 'rgba(0, 0, 0, .4)',
                    display: 'flex',
                    height: 30,
                    margin: 0,
                    fontSize: theme.typography.pxToRem(12),
                    justifyContent: 'center',
                    width: 30,
                  },
                },
              },
              '& .react-datepicker__month': {
                '& .react-datepicker__week': {
                  display: 'flex',
                  '& .react-datepicker__day': {
                    display: 'flex',
                    alignItems: 'center',
                    height: 30,
                    justifyContent: 'center',
                    width: 30,
                    margin: 0,
                    color: 'rgba(0,0,0,.87)',
                    fontSize: 12,
                    '&.react-datepicker__day--outside-month': {
                      color: theme.palette.grey[500],
                    },
                    '&:hover': {
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: '50%',
                      color: '#FFF',
                      fontWeight: 400,
                    },
                    '&.react-datepicker__day--selected': {
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: '50%',
                      fontWeight: 400,
                      color: '#fff',
                    },
                    '&.react-datepicker__day--keyboard-selected': {
                      backgroundColor: theme.palette.primary.main,
                      borderRadius: '50%',
                      fontWeight: 400,
                      color: '#fff',
                    },
                  },
                },
              },
            },
            '& .react-datepicker__time-container': {
              borderLeft: `1px solid ${theme.palette.border.color}`,
              width: 110,
              '& .react-datepicker__header--time': {
                backgroundColor: theme.palette.primary.main,
                border: 0,
                borderRadius: 0,
                '& .react-datepicker-time__header': {
                  color: theme.palette.common.white,
                  fontFamily: theme.typography.fontFamily,
                  fontSize: theme.typography.appFontSize,
                  textTransform: 'capitalize',
                  fontWeight: 500,
                },
              },
              '& .react-datepicker__time': {
                '& .react-datepicker__time-box': {
                  width: '100%',
                  '& .react-datepicker__time-list': {
                    '& .react-datepicker__time-list-item': {
                      alignItems: 'center',
                      boxSizing: 'border-box',
                      color: 'rgba(0,0,0,.87)',
                      display: 'flex',
                      fontSize: 13,
                      justifyContent: 'center',
                      height: 32,
                      '&:hover': {
                        backgroundColor: '#E0E0E0',
                      },
                      '&.react-datepicker__time-list-item--selected': {
                        backgroundColor: '#E0E0E0',
                        color: '#000000DE',
                        fontWeight: 400,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    datepicker: {
      border: 0,
      backgroundColor: 'inherit',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      color: theme.palette.text.primary,
      marginTop: 0,
      width: '100%',
    },
    inputLabel: {
      fontSize: theme.typography.pxToRem(10),
    },
    datepickerStyle: {
      border: 0,
      backgroundColor: 'inherit',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.fontSize,
      color: theme.palette.text.primary,
      marginTop: 0,
      width: '100%',
    },
  };
});

export default useStyles;
